import moment from 'moment'
import { PRO_BASE_URL } from "../config";
import { findNotificationPreferenceType } from '../helpers/NotificationPreferenceType'

export const currentUserNormalizer = data => {
	let { attributes: attr } = data

	let user = {
		id: parseInt(data.id, 10),
		title: attr.title,
		firstName: attr.first_name,
		lastName: attr.last_name,
		email: attr.email,
		lang: attr.default_language,
		sodexoRef: attr.sodexo_reference,
		sodexoRegion: attr.sodexo_region,
		phone: attr.telephone,
		secondaryPhone: attr.secondary_phone,
		landlinePhone: attr.landline_phone,
		contracts: attr.customer_contracts.data.map(normalizeContract),
		scheduledJobs: attr.scheduled_jobs
	}

	if (attr.address !== null) {
		let address = {
			country: attr.address.country,
			lat: attr.address.latitude,
			lng: attr.address.longitude,
			street: attr.address.street_name,
			number: attr.address.street_number,
			city: attr.address.town,
			zip: attr.address.zip,
			display: `${attr.address.street_name} ${attr.address.street_number}, ${attr.address.zip} ${attr.address.town}`
		}

		user.address = address
	}

	user.notificationPreferences = []
	if (attr.notification_preferences !== null) {
		for (let i = 0; i < attr.notification_preferences.length; i++) {
			let notificationPreference = attr.notification_preferences[i]
			let notificationPreferenceType = findNotificationPreferenceType(notificationPreference.label, notificationPreference.notification_type)
			if (notificationPreferenceType) {
				user.notificationPreferences.push({
					type: notificationPreferenceType,
					enabled: notificationPreference.enabled
				})
			}
		}
	}

	return user
}

export const affiliateNormalizer = affiliate => {
	let { attributes: attr } = affiliate
	return {
		id: affiliate.id,
		administrativeEmail: attr.administrative_email,
		email: attr.customer_support_email,
		name: attr.commercial_name,
		lang: attr.default_language,
		phone: attr.telephone,
		logo: PRO_BASE_URL + attr.logo.thumb.url,
		address: {
			inline: attr.address.address,
			lat: attr.address.latitude,
			lng: attr.address.longitude,
		}
	}
}

export const affiliatePublicDataNormalizer = affiliate => {
	let { attributes: attr } = affiliate
	return {
		id: affiliate.id,
		name: attr.commercial_name,
		openingHours: attr.opening_hours.map(oh =>
			({ start: moment(oh.start_time), end: moment(oh.end_time), day: oh.day_of_week.toString() })
		),
		phone: attr.telephone,
		email: attr.customer_support_email,
		areas: attr.areas.map(areaNormalizer),
		logo: PRO_BASE_URL + attr.logo.url,
		cover: PRO_BASE_URL + attr.cover_picture.url,
		slogan: attr.slogan,
		bio: attr.bio,
		address: {
			inline: attr.address.address,
			lat: attr.address.latitude,
			lng: attr.address.longitude,
		}
	}
}

const areaNormalizer = area => {
	return {
		id: area.id,
		zip: area.zip_code,
	}
}

const recurrences = ["once", "every_week", "every_two_weeks"]
export const bookingNormalizer = data => {
	let { id, attributes: attr } = data
	let start = moment(attr.start_time), end = moment(attr.end_time)
	let detailsLink = '/bookings/'
	if (attr.dummy) {
		detailsLink += attr.parent_booking_id + '?date=' + start.format('YYYY-MM-DD')
	} else {
		detailsLink += id
	}
	return {
		id, start, end, detailsLink,
		workerName: attr.worker.display_name,
		workerTitle: attr.worker.title,
		affiliateId: attr.affiliate.id,
		affiliateName: attr.affiliate.commercial_name,
		status: attr.service_delivery_status,
		activities: attr.activities.map(act => bookingActivityNormalizer(act)),
		recurrence: recurrences[attr.recurrence_delay],
		review: attr.review,
		voucherCount: attr.voucher_count,
		voucherType: attr.voucher_type,
		parentBookingID: attr.parent_booking_id,
		dummy: attr.dummy,
		address: {
			inline: `${attr.address.street_name} ${attr.address.street_number}\n${attr.address.zip_code} ${attr.address.town}`,
			lat: attr.address.latitude,
			lng: attr.address.longitude,
		}
	}
}

export const bookingActivityNormalizer = activity => {
	return { date: moment(activity.created_at), id: activity.id, key: activity.key, params: activity.parameters }
}

export const normalizeContract = contract => ({
	id: contract.id,
	affiliateID: contract.attributes.affiliate.data.id,
	startDate: moment(contract.attributes.start_date)
})

export const affiliateMessageNormalizer = message => ({
	id: message.id,
	content: message.attributes.content,
	images: message.attributes.images,
	sender: message.attributes.sender_type,
	createdAt: moment(message.attributes.created_at)
})



// WEBPACK FOOTER //
// ./src/normalizers/Normalizers.js